import { HTMLAttributes } from "react";

export default function IconGrowthPath3(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-9562f95a-03ad-4f31-bb51-e598811ea925"
      data-name="Layer 2"
      viewBox="0 0 63 63"
      {...props}
    >
      <defs>
        <style>
          {
            ".uuid-24ffb962-e6ae-4c4d-ad5d-ed5864b24014{fill:none;stroke:var(--color-primary);stroke-width:3px;stroke-linecap:round;stroke-linejoin:round}"
          }
        </style>
      </defs>
      <g id="uuid-5845839e-a3e1-4ee6-8925-938363784579" data-name="Layer 1">
        <path
          d="M15.57 45.298a10.032 10.032 0 0 1 4.601 4.109M7.471 45.298A10.024 10.024 0 0 0 1.5 54.467v5.913h16.433"
          className="uuid-24ffb962-e6ae-4c4d-ad5d-ed5864b24014"
        />
        <circle
          cx={11.583}
          cy={40.463}
          r={5.975}
          className="uuid-24ffb962-e6ae-4c4d-ad5d-ed5864b24014"
        />
        <path
          d="M55.487 45.28a10.024 10.024 0 0 1 6.013 9.187v5.913H45.02M42.874 49.33a10.033 10.033 0 0 1 4.447-3.983"
          className="uuid-24ffb962-e6ae-4c4d-ad5d-ed5864b24014"
        />
        <circle
          cx={51.417}
          cy={40.463}
          r={5.975}
          className="uuid-24ffb962-e6ae-4c4d-ad5d-ed5864b24014"
        />
        <path
          d="M36.443 44.427a12.963 12.963 0 0 1 4.211 2.815 12.906 12.906 0 0 1 3.792 9.154V61.5H18.554v-5.104c0-5.474 3.397-10.154 8.199-12.048"
          className="uuid-24ffb962-e6ae-4c4d-ad5d-ed5864b24014"
        />
        <circle
          cx={31.5}
          cy={37.475}
          r={7.967}
          className="uuid-24ffb962-e6ae-4c4d-ad5d-ed5864b24014"
        />
        <path
          d="M42.454 11.583v10.954H20.546V11.583l4.979 1.992 5.975-4.98 5.975 4.98 4.98-1.992z"
          style={{
            fill: "none",
            stroke: "var(--color-primary)",
            strokeWidth: 3,
            strokeMiterlimit: 10,
          }}
        />
        <path
          d="M31.5 1.5h0M20.546 4.612h0M42.454 4.612h0"
          className="uuid-24ffb962-e6ae-4c4d-ad5d-ed5864b24014"
        />
      </g>
    </svg>
  );
}
